import React from 'react'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import variables from "../../global/assets/_variables.scss";
import { STORE_NOT_FOUND_404 } from "../../global/assets/Icons"
import { ERROR_CATCH_BLOCK_404_MSG } from "../../global/constants";
import AtomicButton from '../../atomic/button/AtomicButton';

const ErrorCatchBlock404 = (props) => {

    // We need to track this kind of issue to report backend Add analytic reporting 
    // Accept msg as prop and pass it to analyic tool so that backend can fix the error 

    const styleButton = {
        backgroundColor: variables.backgroundDarkBlue,
        width: "90%",
        marginTop: "15px",
        marginBottom: "15px",
        height: "46px",
        width: "266px"
    };
    const tryAgain = () => {
        window.location.reload()
    };


    if (isMobile) {

        return (
            <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>

                <img width='100%' src={STORE_NOT_FOUND_404} alt="" ></img>
                <div style={{
                    display: 'flex', flexDirection: 'column',
                    position: 'absolute', top: '95%',
                    color: '#2998FF', fontFamily: 'Roboto Bold',
                    fontSize: '14px', flex: 'wrap',
                    width: '300px', border: '1px solid black', backgroundColor: 'white', borderRadius: '5px',
                    padding: '20px', justifyContent: 'center', alignItems: 'center', textAlign: 'left'
                }}>
                    {ERROR_CATCH_BLOCK_404_MSG}
                    <AtomicButton
                        label="Try again"
                        handleSubmit={tryAgain}
                        style={styleButton}
                    />
                </div>

            </div>


        )
    }
    return (

        <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>

            <img width='700px' src={STORE_NOT_FOUND_404} alt="" ></img>
            <div style={{
                display: 'flex', flexDirection: 'column',
                position: 'absolute', top: '80%',
                color: '#2998FF', fontFamily: 'Roboto Bold',
                fontSize: '20px', flex: 'wrap',
                width: '500px', border: '1px solid black', backgroundColor: 'white', borderRadius: '5px',
                padding: '20px', justifyContent: 'center', alignItems: 'center', textAlign: 'left'
            }}>
                {ERROR_CATCH_BLOCK_404_MSG}
                <AtomicButton
                    label="Try again"
                    handleSubmit={tryAgain}
                    style={styleButton}
                />
            </div>

        </div>
    )
}

export default ErrorCatchBlock404